var main = require('client_core/main');

module.exports = main;
